import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import MCSpinRecord from "integration/builders/records/mc-spin-record";

export default class IsPickComplete extends Decision {

    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord() as MCSpinRecord;
        const complete = record.complete;

        return complete ? Exit.True : Exit.False;
    }
}
